import { BRANDED_URL } from "@/api";
import { isAllowedBrandedOrigin } from "@/lib/isAllowedBrandedOrigin";

export const navigateToBranded = (token) => {
  const utms = sessionStorage.getItem("utmParams");
  const parsedUtms = utms ? JSON.parse(utms) : null;

  const params = new URLSearchParams();
  params.set("t", token);

  const campaign = sessionStorage.getItem("ls");
  if (campaign) params.set("campaign", campaign);

  if (parsedUtms) {
    for (const [key, value] of Object.entries(parsedUtms)) {
      params.set(key, value);
    }
  }

  const stored = sessionStorage.getItem("returnURL");
  sessionStorage.removeItem("returnURL");

  let base = BRANDED_URL;
  let path = "";
  if (stored) {
    if (stored.startsWith("/")) {
      path = stored.split("?")[0];
    } else {
      try {
        const url = new URL(stored);
        if (isAllowedBrandedOrigin(url.origin)) {
          base = url.origin;
          path = url.pathname;
        }
      } catch {
        // fall back to BRANDED_URL
      }
    }
  }

  window.location.href = `${base}${path}?${params.toString()}`;
};
